'use strict';

/**
 * ValueType for "auto"
 */
const auto = {
    test: (v) => v === "auto",
    parse: (v) => v,
};

exports.auto = auto;
//# sourceMappingURL=auto.cjs.map
